import { render, staticRenderFns } from "./PayoutsHistoryTable.vue?vue&type=template&id=052f5fb5&scoped=true&"
import script from "./PayoutsHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PayoutsHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./PayoutsHistoryTable.vue?vue&type=style&index=0&id=052f5fb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052f5fb5",
  null
  
)

export default component.exports